export class CollectionDownloadTimeoutError extends Error {
    constructor() {
        super('Timed out waiting for the collection zip')
        this.name = 'CollectionDownloadTimeoutError'
    }
}

// Named the way fetch names its own, so one guard covers both the poll giving up and a request cut
// off mid-flight.
export const collectionDownloadAborted = (): Error => {
    const error = new Error('Collection download aborted')

    error.name = 'AbortError'

    return error
}

export const isCollectionDownloadAborted = (error: unknown): boolean =>
    error instanceof Error && error.name === 'AbortError'
